module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs conversions-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/buyout/country',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.by_country')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/buyout/offers',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-briefcase"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.by_offers')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/buyout/couriers',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar-o"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.by_couriers')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/buyout/weeks',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.by_weeks')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/buyout/days',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar-check-o"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.by_days')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/buyout/month',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar-check-o"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.by_month')))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-622fe5de"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/statistics/buyout/BuyoutTabs.vue
// module id = 565
// module chunks = 0